import type { TextWithSideImageComponent } from "../../types";
import { RuntimeImage, RuntimeLink } from "../../runtime/RendererRuntime";
import { getImageObjectPositionStyle, getImageOverrideProps, mergeClassNames, mergeStyles, resolveImageValue } from "../../utils/imageOptions";

/** Text block renderer with side image and governor link. */
export function TextWithSideImageRenderer({ component }: { component: TextWithSideImageComponent }) {
  const { imageSrc, imageAlt, firstParagraph, secondParagraph, governorName, governorHref = "#" } = component.content;
  const { src, options } = resolveImageValue(imageSrc);
  const objectPositionStyle = getImageObjectPositionStyle(options);
  const overrideProps = getImageOverrideProps(options);
  // Replace only the first occurrence of the governor's name with a link in the desktop paragraph
  const linkedSecondDesktop = (() => {
    const idx = secondParagraph.indexOf(governorName);
    if (idx === -1) return secondParagraph;
    return (
      <>
        {secondParagraph.slice(0, idx)}
        {" "}
        <RuntimeLink href={governorHref} className="font-semibold" style={{ color: "#00B862" }}>{governorName}</RuntimeLink>
        {" "}
        {secondParagraph.slice(idx + governorName.length)}
      </>
    );
  })();
  // Plain text for mobile with the same anchor
  const linkedSecondMobile = linkedSecondDesktop;

  return (
    <section>
      <div className="flex flex-col gap-6 md:flex-row md:items-start">
        <article className="min-w-0 flex-1 text-base xl:text-lg leading-7 text-[#121212]">
          <p>{firstParagraph}</p>
          <p className="mt-4 hidden lg:block">
            {linkedSecondDesktop}
          </p>
        </article>
        <div className="hidden md:block md:self-start md:shrink-0 md:basis-auto">
          <RuntimeImage
            src={src}
            alt={imageAlt}
            className={mergeClassNames(
              "h-auto w-[240px] sm:w-[240px] md:w-[220px] lg:w-[300px] max-w-[300px] rounded-sm object-cover",
              overrideProps.className
            )}
            style={mergeStyles(objectPositionStyle, overrideProps.style)}
            priority
          />
        </div>
      </div>
      <div className="mt-4 lg:hidden">
        <p className="text-base xl:text-lg leading-7 text-[#121212]">
          {linkedSecondMobile}
        </p>
      </div>
      <div className="mt-6 flex justify-center md:hidden">
        <RuntimeImage
          src={src}
          alt={imageAlt}
          className={mergeClassNames("h-auto w-[240px] rounded-sm object-cover", overrideProps.className)}
          style={mergeStyles(objectPositionStyle, overrideProps.style)}
          priority
        />
      </div>
    </section>
  );
}



